














































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import HsabInvestmentRedirectPage from "@/employee/components/investments/HsabInvestmentRedirectPage.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import ValueBadge from "@/shared/components/ui/ValueBadge.vue";
import * as RouteNames from "@/employee/route-names";
import {
  EmployeeNavItem,
  HsabSsoDestination,
  InvestmentCustodian,
  ManagedExpenseFilterType
} from "@/shared/types";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useDrivewealthAccountMigrationStore } from "@/shared/store/drivewealthAccountMigration";
import { useUserStore } from "@/shared/store/user";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useThemeStore } from "@/shared/store/theme";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  computed: {
    ManagedExpenseFilterType () {
      return ManagedExpenseFilterType;
    }
  },
  components: {
    ValueBadge,
    SsoDeepLink,
    HsabInvestmentRedirectPage
  }
})
export default class HsaSubMenu extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  hsabInvestmentsStore = useHsabInvestmentStore();
  bankAccountStore = useBankAccountStore();
  drivewealthAccountMigrationStore = useDrivewealthAccountMigrationStore();
  userStore = useUserStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  themeStore = useThemeStore();
  featureFlagStore = useFeatureFlagStore();
  drivewealthStore = useDrivewealthStore();

  RouteNames = RouteNames;
  navItemActive = EmployeeNavItem.None;
  investmentsAdvancedNavVisible = false;

  @Prop()
  userHasAnyNotionalAccounts: boolean;

  created (): void {
    this.investmentThresholdStore.loadInvestmentThresholds({});
  }

  @Watch("$route", {deep: true})
  watchRoute () {
    this.navItemActive = this.$router.currentRoute.meta.nav_item
      ? this.$router.currentRoute.meta.nav_item
      : EmployeeNavItem.None;
  }

  get useInvestmentsAdvancedNav (): boolean {
    return this.drivewealthStore.hasAccountIdOrIds && this.featureFlagStore.flags.bend25653EnableDrivewealthPerformance;
  }

  get contributionsLinkActive () {
    return this.navItemActive === EmployeeNavItem.Contributions;
  }

  get hsabExpenseManagementActive () {
    return this.navItemActive === EmployeeNavItem.ExpenseManagement;
  }

  get showDashboardLink (): boolean {
    const { Home, Dashboard } = RouteNames;
    if (this.featureFlagStore.flags.bend25644EnableSummaryDashboard
        || this.custodianSettingsStore.disabledRoutes[Home]
        || this.custodianSettingsStore.disabledRoutes[Dashboard]) {
      return false;
    }

    return true;
  }

  get hsabDeepLinkDashboard () {
    return HsabSsoDestination.Dashboard;
  }

  get showCashAccountLink (): boolean {
    const { CashBalance } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[CashBalance]) {
      return false;
    }

    return true;
  }

  get showNewClaims (): boolean {
    return this.custodianSettingsStore.displayNewHealthcareExpenses &&
        this.custodianSettingsStore.showHealthcareExpensesV2;
  }

  get showContributionsLink (): boolean {
    const { Contribution } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Contribution]) {
      return false;
    }

    return true;
  }

  get showContributionPlannerLink (): boolean {
    const { ContributionPlanner } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[ContributionPlanner]) {
      return false;
    }

    return true;
  }

}
